import { z } from 'zod'
import _ from 'lodash'
import { RDrugProduct, DrugProduct, Prescription, RPrescription, RIndication, DrugConfirmation } from '@fusion-advantage/backcompat'

export const isPrescription = (m: unknown): m is Prescription => {
	const parsed = RPrescription.safeParse(m)
	return parsed.success
}

export const newPrescription = (product: DrugProduct): Prescription => ({
	Product: product,
	Indications: [],
	InUse: null,
	IsPrior: false,
	Confirmation: null,
	Reason: null,
})

export const RPrescriptionHistoryItem = z.object({
	Product: RDrugProduct,
	Indications: z.optional(z.array(RIndication)),
})
export type PrescriptionHistoryItem = z.infer<typeof RPrescriptionHistoryItem>

export interface DrugScannerResult {
	product: z.TypeOf<typeof RDrugProduct>
	codes: z.TypeOf<typeof RIndication>[]
	fromJs: boolean
    isPrior: boolean
    confirmation: DrugConfirmation|null
}

export const prescriptionsFromScanner = (existingModels: Prescription[], results: DrugScannerResult[]): Prescription[] => {
	const clonedExisting = _.cloneDeep(existingModels)
	const existingDrugIds = existingModels.map(x => x.Product.ID)
	const newDrugs = results.filter(x => existingDrugIds.includes(x.product.ID) === false)
	const updatedDrugs = results.filter(x => existingDrugIds.includes(x.product.ID) === true)

	_.forEach(updatedDrugs, (update) => {
		const existingModel = clonedExisting.find(x => x.Product.ID === update.product.ID)

		if(existingModel) {
			existingModel.Confirmation = DrugConfirmation.Scan
			existingModel.InUse = true
		}
	})

	return [
		...clonedExisting,
		...newDrugs
			.map(result => ({
				...newPrescription(result.product),
				Confirmation: DrugConfirmation.Scan,
				InUse: true,
				Reason: null,
			})),
	]
}

export const mergeHistoricalPrescriptions = (prescriptions: Prescription[], historicalPrescriptions: PrescriptionHistoryItem[]): Prescription[] => {
	const allPrescriptions: Prescription[] = prescriptions

	_.forEach(historicalPrescriptions, (hMed) => {
		let presc = allPrescriptions.find(x => x.Product.ID === hMed.Product.ID)

		if(presc) {
			presc.Indications = _.uniqWith([...presc.Indications, ...(hMed.Indications || [])], _.isEqual)
			presc.IsPrior = true
		}
		else {
			presc = newPrescription(hMed.Product)
			presc.Indications = hMed.Indications || []
			presc.IsPrior = true

			allPrescriptions.unshift(presc)
		}
	})

	return allPrescriptions
}